import fs from 'node:fs'
import { parseDocument } from 'yaml'
import { findPnpmWorkspacePath } from './find-pnpm-workspace-path.js'

export function ensurePnpmAllowedBuilds(cwd: string, dependencies: string[]): void {
  if (dependencies.length === 0) {
    return
  }

  const workspacePath = findPnpmWorkspacePath(cwd)
  const workspaceContent = fs.existsSync(workspacePath)
    ? fs.readFileSync(workspacePath, 'utf-8')
    : '{}\n'
  const workspaceDocument = parseDocument(workspaceContent)
  if (workspaceDocument.errors.length > 0) {
    throw new Error(
      `Could not update pnpm-workspace.yaml: ${workspaceDocument.errors[0]?.message ?? 'invalid YAML'}`
    )
  }

  let workspaceChanged = false
  for (const dependency of dependencies) {
    const valuePath = ['allowBuilds', dependency]
    const currentValue = workspaceDocument.getIn(valuePath)
    if (currentValue === undefined || currentValue === 'set this to true or false') {
      workspaceDocument.setIn(valuePath, true)
      workspaceChanged = true
    }
  }

  if (workspaceChanged) {
    fs.writeFileSync(workspacePath, workspaceDocument.toString({ lineWidth: 0 }), 'utf-8')
  }
}
